import { Paper, Typography, Box, Stack, Pagination } from '@mui/material';
import { useFotosProdutosStore } from '../../store/FotosProdutosStore';


import FiltrosBusca from '../../components/FiltroDeBuscaDeFotos';
import CardsFotos from '../../components/CardDefotosProdutos'
import ModalUploadFotos from '../../components/ModalUploadDeFotos'
import ConfirmDeleteModal from '../../components/ModalDeConfirmacao';

import { useCallback, useEffect, useState } from 'react';

export default function FotosProdutosPage() {

    const {
        searchFotos,
        fetchFotos,
        produtos,
        carregando,
        deletingId,
        pagina_atual,
        ultima_pagina,
        SalvarFoto,
        setCodProduto,
        fecharModalDeUpload,
        setCodProdutoDelete,
        DeletarFoto
    } = useFotosProdutosStore();

    const [modalCriacaoAberto, setmodalCriacaoAberto] = useState(false);
    const [ModalConfirmacao, setModalConfirmacao] = useState(false);
    const [msgModalConfirmacao, setMsgModalConfirmacao] = useState('');



    useEffect(() => {
        fetchFotos();
    }, [])

    const handleBusca = useCallback((filtros) => {
        searchFotos(filtros)
    }, []);

    const handleLimparBusca = useCallback(() => {
        fetchFotos(1);
    }, []);

    const handleAbrirModalCriacao = useCallback((cod_produto) => {
        setCodProduto(cod_produto)
        setmodalCriacaoAberto(true);
    }, [])

    const handleAbrirModalConfirmacao = useCallback((cod_produto) => {
        setCodProdutoDelete(cod_produto)
        setModalConfirmacao(true)
        setMsgModalConfirmacao('Deseja realmente excluir a foto deste produto?');
    }, [])

    const handleFecharModalConfirmacao = useCallback((cod_produto) => {
        setModalConfirmacao(false)
        setMsgModalConfirmacao("");
    }, [])

    const handleConfirmarExlusao = useCallback(() => {
        handleFecharModalConfirmacao();
        setMsgModalConfirmacao('');
        DeletarFoto(deletingId);
    }, []);



    const handleFecharModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(false);
    }, [])


    const handleSalvarCriacao = useCallback((imagem) => {
        SalvarFoto(imagem)
    }, [])

    const handlePageChange = useCallback((event, page) => {
        fetchFotos(page);
    }, []);

    useEffect(() => {
        if (fecharModalDeUpload) {
            setmodalCriacaoAberto(false);
            // se quiser reabrir o modal depois, reseta o estado:
            useFotosProdutosStore.setState({ fecharModalDeUpload: false });
        }
    }, [fecharModalDeUpload])


    return (
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '99%', backgroundColor: 'transparent' }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de Fotos
            </Typography>

            <FiltrosBusca
                onClear={handleLimparBusca}
                onSearch={handleBusca}
            />

            <Box sx={{ mt: 4 }}>
                <CardsFotos
                    produtos={produtos}
                    onEdit={handleAbrirModalCriacao}
                    onDelete={handleAbrirModalConfirmacao}
                    loadingState={{ carregando, deletingId }}
                />
            </Box>

            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
                <Pagination
                    page={pagina_atual}
                    count={ultima_pagina}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    disabled={carregando !== 'idle'}
                />
            </Stack>

            {/* MODAL DE CRIACAO */}
            {modalCriacaoAberto && (
                <ModalUploadFotos
                    open={modalCriacaoAberto}
                    onClose={handleFecharModalCriacao}
                    onSave={handleSalvarCriacao}
                    isLoading={carregando}
                />
            )}


            {
                ModalConfirmacao && (
                    <ConfirmDeleteModal
                        mensagem={msgModalConfirmacao}
                        open={ModalConfirmacao}
                        onClose={handleFecharModalConfirmacao}
                        titulo={'Atenção'}
                        onConfirm={() => { handleConfirmarExlusao() }}
                    />
                )
            }

        </Paper>
    )
}